/* eslint-disable react/no-array-index-key */
import React from 'react'
import { useStore } from 'effector-react'
import cx from 'classnames'
import { Button } from '@finanso/react-uikit'

import styles from './Card.module.scss'

import ArrowCheck from '../../../../../assets/images/ArrowCheck'
import { StatusCard } from '../../../enum/StatusCard'
import { $handlerTariff } from '../../../../state/Tariff/store'
import { CardSkeleton } from './Card.skeleton'
import { Period, Subscribe } from '../../../../services/api/Tafiff'
import { Translate } from 'react-localize-redux'

export interface CardProps extends Subscribe {
  loading?: boolean
}

export const Card: React.FC<CardProps> = ({
  currency,
  price,
  name,
  period,
  id,
  loading,
  description,
  descriptionInfo,
}) => {
  const handlerTariff = useStore($handlerTariff)

  const periodAlias = period === Period.MONTH ? 'tariff.title.period.month' : 'tariff.title.period.year'

  if (loading) {
    return <CardSkeleton />
  }
  return (
    <div className={cx(
      styles.root,
      name === StatusCard.RECOMENDATE && styles.recomendate,
      name === StatusCard.PRO && styles.pro,
    )}
    >
      <div>
        <div className={styles.label}>
          {name}
        </div>

        <div className={styles.price}>
          {name === StatusCard.FREE
            ? <div className={styles.free}>
              <Translate id={'tariff.title.price.free'} />
            </div>
            : <div className={styles.rate}>
              <span className={styles.profit}>
                {price} {currency}
                &nbsp;
                <span className={styles.term}>
                  <Translate id={periodAlias} />
                </span>
              </span>

              {/* <span className={styles.oldprice}> */}
              {/*  {oldPrice[0]} */}
              {/*  <span className={styles.term}>&nbsp;{oldPrice[1]}</span> */}
              {/* </span> */}
            </div>
          }
        </div>

        <div className={styles.description}>
          {description}
        </div>

        <div className={styles.list}>
          {descriptionInfo.map(({ value, isActive }) => (
            <div
              className={cx(
                styles.option,
                !isActive && styles.close,
              )}
              key={`${value}`}
            >
              <ArrowCheck className={styles.check} /> {value}
            </div>
          ))}
        </div>
      </div>

      <Button
        className={cx(styles.button)}
        onClick={() => handlerTariff(id)}
        color={name === StatusCard.PRO ? 'success' : undefined}
      >
        <Translate id={`tariff.button.${name.toLowerCase()}`} />
      </Button>
    </div>
  )
}
